import { VuetifyTiptap, VuetifyViewer, createVuetifyProTipTap } from 'vuetify-pro-tiptap'
import {
  BaseKit,
  Bold,
  Italic,
  Underline,
  Strike,
  Heading,
  BulletList,
  Link,
  Image,
  History
} from 'vuetify-pro-tiptap'
import 'vuetify-pro-tiptap/style.css'

export const vuetifyProTipTap = createVuetifyProTipTap({
  lang: 'de',
  components: {
    VuetifyTiptap,
    VuetifyViewer
  },
  extensions: [
    BaseKit,
    Bold,
    Italic,
    Underline,
    Strike,
    Heading.configure({
      levels: [3, 4, 5, 6]
    }),
    BulletList,
    Link,
    Image.configure({
      hiddenTabs: ['upload']
    }),
    History
  ]
})
